import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getSetCookie from './../../../cookie';
import { provideHooks } from 'redial';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import Header from '../Header/Header';
import { renderRoutes } from 'react-router-config';
import Footer from '../../components/Footer/Footer';
import Shortlist from '../../components/Common/Shortlist';
import * as headerCallsActionCreators from './../../../actionCreators/header';
import * as commonCallsActionCreators from './../../../actionCreators/common';
import * as campaignCallsActionCreators from '../../../actionCreators/campaign';
import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import * as homeCallsActionCreators from './../../../actionCreators/home';
import * as checkoutCallsActionCreators from '../../../actionCreators/checkout';
import { getLocaleData } from '../../../actionCreators/locale';
import { getYotpoSiteRatings } from '../../../actionCreators/yotpo';

import { appendScriptToDOM, isSearchCrawler, isEmptyObject } from '../../../utils/helper';
import config from 'config';
// import cartPixel from './../../../addCartPixel';
import 'custom-event-polyfill';
import './App.scss';
import AppHelmet from '../../../CommonComponents/Helmet/AppHelmet';
import CrossCountryStrip from '../../components/CrossCountryStrip/CrossCountryStrip';

@provideHooks({
  fetch: async ({ location, reqHeaders, store: { dispatch, getState } }) => {
    const state = getState();
    // get locale config data
    if (isEmptyObject(state.locale)) {
      dispatch(getLocaleData());
    }
    if (state.common.wishlistTrue === true) {
      dispatch(commonCallsActionCreators.showWishlist(false));
    }
    if (
      (location.pathname && location.pathname.indexOf('/checkout/onepage') !== -1) ||
      location.pathname.indexOf('presales') !== -1 ||
      location.pathname.indexOf('/sales/order') > -1 ||
      location.pathname.indexOf('/checkout/payment/qr') !== -1 ||
      location.pathname.toLowerCase().indexOf('/hto') !== -1
    ) {
      dispatch(showGlobalHeaderFooter({ header: false, footer: false }));
      if (__SERVER__) {
        await dispatch(commonCallsActionCreators.validateSession(location.pathname));
      }
    } else {
      dispatch(showGlobalHeaderFooter({ header: true, footer: true }));
    }
    if (__CLIENT__) {
      if (state.common.login !== Boolean(parseInt(getSetCookie.getCookie('isLogined'), 10))) {
        dispatch(commonCallsActionCreators.getUserInfo());
      }
    }
    const mainNavigationData = state.header.mainNavigationData;
    const redisCommonData = state.common.redisCommonData;
    if (__SERVER__) {
      const uA = reqHeaders['user-agent'];
      const isBot = uA ? isSearchCrawler(uA) : false;
      if (!mainNavigationData || isEmptyObject(mainNavigationData)) {
        await dispatch(headerCallsActionCreators.getMainNav());
      }
      // await dispatch(headerCallsActionCreators.getTopNavDataFromLocal());
      if (!redisCommonData || isEmptyObject(redisCommonData)) {
        await dispatch(commonCallsActionCreators.getRedisData(isBot));
      }
    }
    if (
      location.pathname &&
      (location.pathname.indexOf('/reviews') !== -1 ||
        location.pathname.indexOf('/shop-instagram') !== -1)
    ) {
      dispatch(commonCallsActionCreators.changeLogo('lenskart'));
    }
  },
  defer: ({ store: { dispatch, getState } }) => {
    const state = getState();
    const countryCode = getSetCookie.getCookie('countryCode');
    const { countryData } = state.common;
    const { showGlobalHeader } = state.header;
    // get locale config data
    if (isEmptyObject(state.locale)) {
      dispatch(getLocaleData());
    }
    if (countryCode && countryCode.toLowerCase() !== 'in' && !countryData && showGlobalHeader) {
      dispatch(commonCallsActionCreators.getCountryData(countryCode));
    }
    if (__SERVER__) {
      dispatch(getYotpoSiteRatings());
    }
  },
})
class App extends Component {
  static propTypes = {
    commonCallsActionCreators: PropTypes.any.isRequired,
    headerCallsActionCreators: PropTypes.any.isRequired,
    homeCallsActionCreators: PropTypes.any.isRequired,
    redisCommonData: PropTypes.any,
    mainNavigationData: PropTypes.any,
    isMenuVisible: PropTypes.bool,
    showGlobalHeader: PropTypes.bool,
    loginStatus: PropTypes.bool,
    wishlistTrue: PropTypes.bool,
    route: PropTypes.objectOf(PropTypes.any).isRequired,
    showWishlist: PropTypes.func,
    isWishlistCount: PropTypes.number,
    isCartCount: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.checkId = this.checkId.bind(this);
    this.campaignTimerId = null;
  }
  componentDidMount() {
    const {
      commonCallsActionCreators,
      loginStatus,
      homeCallsActionCreators,
      location,
      redisCommonData
    } = this.props;
    let path =
      location && location.pathname.length > 1
        ? location.pathname.slice(1).replace(/(\/+)$/g, '')
        : '/';
    path = path !== '' ? path : '/';
    setTimeout(() => {
      if (
        [
          'eyeglasses.html',
          'sunglasses.html',
          'premium-eyeglasses',
          'premium-sunglasses',
          '/',
        ].includes(path) ||
        path.indexOf('promo/') > -1
      ) {
        homeCallsActionCreators.loadCarousalsData();
      }
    }, 50);
    this.loadThirdPartyLibraries();
    window.ReactPixel = require('react-facebook-pixel');
    const { init, pageView } = window.ReactPixel.default;
    init('790230201013876');
    pageView();
    this.resetCampaignData();
    // if (getSetCookie.getCookie('frontend') === '') {
    //   commonCallsActionCreators.setJunoSession();
    // }
    if (!getSetCookie.getCookie('session')) {
      getSetCookie.setCookie('session', 'sticky', 14);
    }
    if (!loginStatus && getSetCookie.getCookie('frontend')) {
      setTimeout(() => {
        commonCallsActionCreators.validateSession(location.pathname);
      }, 500);
    }
    // headerCallsActionCreators.getMainNav();
    if (window.dtm === undefined) {
      window.dtm = {};
      window.dtm.pageName = 'baseAbort';
    }
    if (window.dtm) {
      window.dtm.site = 'webDesktop';
      window.dtm.sessionID = getSetCookie.getCookie('omniSession');
      window.dtm.loginStatus = loginStatus ? 'registered' : 'guest';
    }
    window.localStorage.removeItem('showEnterAddress');
    // desktopGTM event for omni and gtm
    if (typeof window.desktopGTM === 'undefined') {
      window.desktopGTM = document.createEvent('Event');
      window.desktopGTM.initEvent('desktopGTM', true, true);
      window.setTimeout(() => {
        window.dispatchEvent(window.desktopGTM);
        if (
          typeof window.FMApi === 'object' &&
          typeof window.FMApi.manualTriggerExperiment === 'function'
        ) {
          window.FMApi = window.FMApi || [];
          window.FMApi.push('fm_activate_adobe_integration');
        }
      }, 800);
    }

    setTimeout(() => {
      if (process.env.BUILD_ENV === 'production') {
        // TrackJs Call
        const db = indexedDB.open('test');
        db.onsuccess = () => {

          appendScriptToDOM(
            'https://cdn.trackjs.com/agent/v3/latest/t.js',
            'trackjs',
            true,
            () => {
              window.TrackJS.install({
                token: '366385441bae430b923e6cd6935e9c44',
                application: 'lenskart-web',
                enabled: !(window.location.host.indexOf('localhost') >= 0 || window.location.host.indexOf('lenskart.com:8081') >= 0)
              });
            }
          );
        };
        // Live Chat Js Call
        if (sessionStorage.getItem('session') !== 'doctor') {
          window.__lc = window.__lc || {};
          window.__lc.license = 1195391;
          (() => {
            const lc = document.createElement('script');
            lc.type = 'text/javascript';
            lc.async = true;
            lc.src = `${document.location.protocol === 'https:' ? 'https://' : 'http://'
              }cdn.livechatinc.com/tracking.js`;
            const st = document.getElementsByTagName('script')[0];
            st.parentNode.insertBefore(lc, st);
          })();
        }
      }
    }, 3000);
    commonCallsActionCreators.getAudienceType();
    if (redisCommonData?.ENABLE_FRESHWORKS_DESKTOP === 'OFF') {
      setTimeout(() => {
        const freshwidget = document.getElementById('freshworks-container');
        if (freshwidget) {
          freshwidget.style.display = 'none';
        }
      }, 0);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      loginStatus,
      userInfo,
      isValidSession,
      commonCallsActionCreators,
      addToCartFailed,
    } = this.props;
    this.resetCampaignData(prevProps);
    if (prevProps.isValidSession !== isValidSession && isValidSession === 401) {
      commonCallsActionCreators.setJunoSession();
    }
    if (
      !prevProps.isWishlistCount &&
      this.props.isWishlistCount &&
      getSetCookie.getCookie('frontend') !== '' &&
      this.props.location.pathname &&
      this.props.location.pathname.indexOf('/checkout/onepage/') === -1
    ) {
      // const { commonCallsActionCreators } = this.props;
      commonCallsActionCreators.shortlist('', 'get', '?attributes=true');
      // if (wishlistTrue) commonCallsActionCreators.showWishlist(false);
    }

    // update DTM login status
    if (loginStatus && userInfo) {
      const { result: { phoneCode, telephone, lastName, firstName, gender } } = userInfo;
      window.dtm.loginStatus = 'registered';
      window.dtm.customerID = userInfo && userInfo.result.id;
      const gaData = {
        Name: `${firstName} ${lastName}`,
        Identity: telephone,
        Phone: `${phoneCode}${telephone}`
      };
      if (gender && gender.toLowerCase().indexOf('male') > -1) {
        const genderType = gender.toLowerCase();
        gaData.Gender = genderType === 'male' ? 'M' : 'F';
      }
      if (typeof window.clevertap !== 'undefined' && userInfo) {
        window.clevertap.onUserLogin.push({
          Site: gaData,
        });
      }
    } else {
      window.dtm.loginStatus = 'guest';
      delete window.dtm.customerID;
    }

    if (
      prevProps.addToCartFailed === null &&
      addToCartFailed !== null &&
      addToCartFailed.status === 422 &&
      location.pathname !== '/HTO'
    ) {
      if (addToCartFailed.message.indexOf('out of stock') !== -1) {
        alert('This product is Out of Stock !');
      } else {
        alert(addToCartFailed.message);
      }
      return window.location.reload();
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.sessionStorage.setItem('previousChannel', window.dtm.channel);
    }

    // if (prevProps.cartData !== cartData) {
    //   cartPixel.fireFbq(cartData.result.items, 'AddToCart');
    // }
    const freshBotHide = document.getElementById('mobile-chat-container')?.className?.includes('joe-hide');
    if (location.pathname.indexOf('/customer-support') === -1 && window.Freshbots && !freshBotHide) { window.Freshbots.hideWidget(true); }
  }

  loadThirdPartyLibraries = () => {
    const { redisCommonData } = this.props;
    const freshmarketerEnabled =
      redisCommonData && redisCommonData.ENABLE_FRESHWORKS_DESKTOP === 'ON';
    window.UnbxdSiteName = 'lenskart_com-u1418736834941';
    appendScriptToDOM(
      `https://staticw2.yotpo.com/${config.yotpoConfig.apiKey}/widget.js`,
      'yotpo_widget_lk',
      true,
      null
    );
    appendScriptToDOM(
      'https://d21gpk1vhmjuf5.cloudfront.net/unbxdAnalytics.js',
      'vendor_unbxd',
      true,
      null
    );
    if (freshmarketerEnabled) {
      appendScriptToDOM(
        'https://static.lenskart.com/media/desktop/js/jquery-3.5.1.slim.min.js',
        '',
        false,
        null
      );
      appendScriptToDOM(
        'https://cdn.freshmarketer.com/232805/806426.js',
        'vendor_freshmarketer',
        true,
        null
      );
    }
  };
  resetCampaignData = prevProps => {
    const {
      timeToResetData,
      campaignCallsActionCreators,
      section,
      dataCampaign,
      location,
      categoryData,
      productData,
    } = this.props;
    if (prevProps && prevProps.section !== section) {
      clearTimeout(this.campaignTimerId);
    } else if (
      prevProps &&
      prevProps.section === section &&
      prevProps.dataCampaign === dataCampaign
    ) {
      return;
    }
    if (!timeToResetData) {
      return;
    }
    if (['prod', 'cat', ''].includes(section)) {
      clearTimeout(this.campaignTimerId);
      this.campaignTimerId = setTimeout(() => {
        let sectionContext;
        if (section === '') {
          if (location.pathname === '/checkout/onepage/') {
            sectionContext = 'checkout';
          } else {
            sectionContext =
              location.pathname === '/' ? 'home' : location.pathname.slice(1).replace('.html', '');
          }
        }
        campaignCallsActionCreators.getCampaignData({
          pageContext: section !== '' ? section : sectionContext,
          usePristineData: true,
          categoryData: categoryData ? categoryData.result : {},
          productData: productData ? productData.result : {},
        });
      }, timeToResetData);
    }
  };

  checkId() {
    if (this.props.shortListData.result.productList !== null) {
      this.props.shortListData.result.productList.forEach(value => {
        if (this.props.productPageId === value.id) {
          this.props.toggleWishlist(true);
        }
      });
    } else if (this.props.shortListData.result.productList.length === 0) {
      this.props.toggleWishlist(false);
    }
  }

  render() {
    const {
      mainNavigationData,
      section,
      loginStatus,
      route,
      isFilterEnable,
      showGlobalHeader,
      showGlobalFooter,
      location,
      countryData,
      dataLocale
    } = this.props;
    return (
      <React.Fragment>
        <AppHelmet pathname={location.pathname}></AppHelmet>
        <div className={isFilterEnable ? 'vertical-filter' : ''}>
          {/* redisLoading ? <div style={{ zIndex: '99999', left: '0', width: '100%', position: 'fixed', top: '0' }}><Pace height={4} color="orange" /></div> : null */}
          {showGlobalHeader && <Header {...this.props} />}
          {Boolean(showGlobalHeader && countryData && !isSearchCrawler()) && (
            <CrossCountryStrip countryData={countryData} dataLocale={dataLocale} />
          )}
          {/* routes setup */}
          {renderRoutes(route.routes)}
          {showGlobalFooter && (
            <Footer
              mainNavigationData={mainNavigationData}
              section={section}
              loginStatus={loginStatus}
              location={location}
            />
          )}
          <Shortlist checkId={this.checkId} {...this.props} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  redisCommonData: state.common.redisCommonData,
  loginStatus: state.common.login,
  wishlistTrue: state.common.wishlistTrue,
  mainNavigationData: state.header.mainNavigationData,
  showGlobalHeader: state.header.showGlobalHeader,
  showGlobalFooter: state.header.showGlobalFooter,
  isMenuVisible: state.header.isMenuVisible,
  userInfo: state.common.userInfo,
  loginLoader: state.common.loginLoader,
  shortListData: state.common.shortListData,
  cartData: state.cart.cartData,
  redisLoading: state.common.redisLoading,
  countryData: state.common.countryData,
  isFilterEnable: state.category.isFilterEnable,
  router: state.router,
  isWishlistCount: state.common.isWishlistCount,
  isCartCount: state.common.isCartCount,
  isSupported: state.common.isSupported,
  checkBrowser: state.common.checkBrowser,
  section: state.common.section,
  isValidSession: state.common.errorCode,
  addToCartFailed: state.cart.addToCartFailed,
  dataCampaign: state.campaign.dataCampaign,
  timeToResetData: state.campaign.timeToResetData,
  categoryData: state.category.categoryData,
  productData: state.product.productData,
  dataLocale: state.locale
});

function mapDispatchToProps(dispatch) {
  return {
    commonCallsActionCreators: bindActionCreators(commonCallsActionCreators, dispatch),
    headerCallsActionCreators: bindActionCreators(headerCallsActionCreators, dispatch),
    campaignCallsActionCreators: bindActionCreators(campaignCallsActionCreators, dispatch),
    checkoutCallsActionCreators: bindActionCreators(checkoutCallsActionCreators, dispatch),
    homeCallsActionCreators: bindActionCreators(homeCallsActionCreators, dispatch),
  };
}

App.defaultProps = {
  redisCommonData: {},
  loginStatus: false,
  wishlistTrue: false,
  mainNavigationData: {},
  showGlobalHeader: true,
  isMenuVisible: true,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
